<template>
  <div class="color-picker">
    <div
      :class="{'active': isActive}"
      class="color-picker__brush box"
      @click="$emit('selected')"
    >
      <i class="fas fa-paint-brush box__icon" />
      {{ label }}
    </div>
    <div
      :style="chosenColor"
      class="color-picker__box box"
    >
      <i 
        class="fa fa-tint" 
        @click="openMenu()"
      />
      <div
        v-show="showPicker"
        class="color-picker__picker"  
      >
        <div
          v-for="(row, index) in colorList"
          :key="index"
          class="color-picker__picker__row"
        >
          <div
            v-for="(color, index) in row"
            :key="index"
            :style="bgPicker(color)"
            class="color-picker__picker__row__box"
            @click="setColor(color)"
          />
        </div>
        <div
          class="color-picker__picker__row"
        >
          <div
            :style="bgPicker(white)"
            class="color-picker__picker__row__big"
            @click="setColor(white)"
          />
          <div
            :style="bgPicker(black)"
            class="color-picker__picker__row__big"
            @click="setColor(black)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: {
      type: Boolean,
      default: false,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: true,
      required: false
    },
    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      colorList: [],
      selectedArray: [0, 0, 0, 1],
      showPicker: false,
      white: [0, 100, 100],
      black: [0, 0, 0]
    };
  },

  computed: {
    color: {
      set: function(newValue) {
        this.$emit("input", newValue);
      },
      get: function() {
        return this.value;
      }
    },
    chosenColor() {
      return `background-color: ${this.color};`;
    }
  },

  watch: {
    close: function() {
      this.showPicker = false;
    }
  },

  created: function() {
    this.colorList = this.genColorList(10, 10);
  },

  methods: {
    bgPicker(colors) {
      // eslint-disable-next-line
      let bg = `background-color: ${this.setHSLColor(colors)}`;
      return bg;
    },
    colorWhite: function(colors) {
      if (colors[0] == 255 && colors[1] == 255 && colors[2] == 255) return true;
      return false;
    },
    colorBlack: function(colors) {
      if (colors[0] == 0 && colors[1] == 0 && colors[2] == 0) return true;
      return false;
    },
    genColorList: function(row, col) {
      let hueStep = 360 / row;
      let saturationStep = 80 / col;
      let colorArray = [];

      for (let hue = 360; hue > 0; hue -= hueStep) {
        let rowArray = [];
        for (
          let saturation = 20;
          saturation < 100;
          saturation += saturationStep
        ) {
          rowArray.push([hue, 100, saturation]);
        }
        colorArray.push(rowArray);
      }

      return colorArray;
    },
    openMenu: function() {
      this.togglePicker();
      this.$emit("menuopen");
      this.$emit("selected");
    },
    setColor: function(colorArray) {
      //this.color = this.setRGBAColor(colorArray);
      this.color = this.setHSLColor(colorArray);
      this.selectedArray = colorArray;
      this.showPicker = false;
      this.$emit("selected");
    },
    setHSLColor: function(colors) {
      return `hsl(${colors[0]}, ${colors[1]}%, ${colors[2]}%)`;
    },
    setRGBAColor: function(colors) {
      // eslint-disable-next-line
      if (colors) return `rgba(${colors[0]}, ${colors[1]}, ${colors[2]}, ${colors[3]})`;
      // eslint-disable-next-line
      return `rgba(${this.brushRed}, ${this.brushGreen}, ${this.brushBlue}, ${this.brushAlpha})`;
    },
    togglePicker: function() {
      this.showPicker = !this.showPicker;
    }
  }
};
</script>

<style lang="scss">
.color-picker {
  align-items: center;
  display: flex;

  &__box {
    border-radius: 0.25rem;
    position: relative;
    color: #7f7f7f;
    border: 1px solid #222;
    padding: 0;

    .fa {
      margin: 0 -1rem;
      padding: 0px 1.2rem;
      color: white;
      text-shadow: 0 0 10px rgba(black, 0.4);
    }
  }
}

.color-picker__picker {
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  max-height: 90vh;
  min-width: 28rem;
  position: absolute;
  padding: 1rem;
  top: 3.2rem;
  overflow: auto;
  z-index: 21;

  &__row {
    display: flex;
    justify-content: space-between;
    &__box {
      border-radius: 0.2rem;
      height: 2.5rem;
      margin: 0.1rem;
      width: 2.5rem;
    }

    &__big {
      border: 1px solid rgba(0, 0, 0, 0.3);
      border-radius: 0.2rem;
      flex: 1 0 auto;
      margin: 0.1rem;
      height: 2.5rem;
    }
  }
}
</style>
